import type { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { Severity } from "type";
import getMstMainOptionsApi from "../api/getMstMainOptionsApi";
import downloadMstMainCsv from "../api/downloadMstMainCsv";
import { DownloadMstMainParam, MstOption } from "../types";

/**
 * Custom hooks to use system usage as CSV.
 * @param showAlert アラート表示
 */
export default function useMstMain(showAlert: (msg: string, severity?: Severity) => void) {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);
  const [mstOptions, setMstOptions] = useState<MstOption[]>([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const getMstOptions = useCallback(async () => {
    setIsOptionsLoading(true);
    try {
      const options = await getMstMainOptionsApi();
      setMstOptions(options);
    } catch (error) {
      console.error(error);
      showAlert("マスタ情報の取得に失敗しました", "error");
    } finally {
      setIsOptionsLoading(false);
    }
  }, []);
  const handleDownload = useCallback(async () => {
    setIsDownloading(true);
    try {
      // const safeTarget = target ?? 1;
      if (selectedIndex === undefined) {
        showAlert('先に対象マスタを選択してください。', 'error');
        return;
      }
      const params: DownloadMstMainParam = {
        table_name: mstOptions[selectedIndex].tableName
      };
      await downloadMstMainCsv(params);
    } catch (error) {
      console.error(error);
      showAlert("CSVのダウンロードに失敗しました", "error");
    } finally {
      setIsDownloading(false);
    }
  }, [mstOptions, selectedIndex]);

  return {
    mstOptions,
    selectedIndex,
    setSelectedIndex,
    getMstOptions,
    handleDownload,
    isOptionsLoading,
    isDownloading,
  };
}
